<template>
    <div>
        <p v-if="restartDate" class="restart-date--information" v-text="restartDateString"></p>
        <div class="deliveryAddressCard__action" @click="resumeSubscription">
            <p class="no-margin" v-text="resumeDeliveriesText"></p>
            <img class="deliveryAddressCard__actionIcon" src="@/assets/images/decoration/nav_resume.svg">
        </div>
    </div>
</template>

<script>
import { formatDate } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ResumeDeliveries',
    props: {
        subscription: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        restartDate() {
            return this.subscription?.resume_date;
        },
        restartDateString() {
            return this.restartDate ? this.$t('DELIVERY_CARD_RESTART_DATE', { restartDate: formatDate(this.restartDate, Dates.DAY_DATE_MONTH_YEAR) }) : false;
        },
        resumeDeliveriesText() {
            return this.restartDate ? this.$t('DELIVERY_CARD_RESUME_NOW') : this.$t('DELIVERY_CARD_RESUME');
        },
    },
    methods: {
        fetchData() {
            this.$store.dispatch('subscription/fetchAllSubscriptions', true);
            this.$store.dispatch('address/fetchAllAddresses', true);
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        },
        resumeSubscription() {
            subscriptionService.continueSubscription(this.subscription.id)
                .then(() => {
                    this.$emit('deliveries-resumed');
                    this.fetchData();
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
    },
};
</script>

<style lang="scss" scoped>
.restart-date--information {
    font-size: 16px;
    margin: 0;
    padding: 15px 20px 0;
    text-align: left;
}
</style>
